import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=8514dda2&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=8514dda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8514dda2",
  null
  
)

export default component.exports